<template>
	<div class='tw-flex tw--mx-3'>
		<div class="tw-w-1/2 px-3">
			<div class="tw-mb-3">
				<guideline-job-form
					@jobAdded='onJobNameAdded'
					:job-list="jobList"
					:max-jobs-list="15"
				/>
			</div>
			<div>
				<guideline-job-list
					:job-list="jobList"
					:selected-job="selectedJob"
					@deleteClick="onDeleteClick"
					@editionClick="onEditionClick"
				/>
			</div>
		</div>
		<div class="tw-w-1/2  px-3">
			<guideline-job-selector
				v-show="jobIsSelected"
				:selected-prev="selectedPrev"
				:selected-next="selectedNext"
				:selected-job="selectedJob"
				@selectedJobDataChanged="onSelectedJobDataChanged"
				@prevClick="onPrevClick"
				@nextClick="onNextClick"
				@infoClick="onInfoClick"
				:job-list-navigation="true"
				:show-info-icon="true"
				ref="jobSelector"
			>
				<template slot="action-footer">
					<v-btn
						:disabled="!selectionIsReady"
						class="custom-button tw-px-8"
						color="primary"
						@click="onGenerateHierarchyClick"
					>Asignar Jerarquía</v-btn>
					<p v-if="!selectionIsReady" class="tw-mt-2 tw-mb-0">Finaliza de cofigurar todos tus puestos de trabajo para continuar</p>
				</template>
			</guideline-job-selector>
			<guideline-model-instructions v-show="!jobIsSelected" />
		</div>
	</div>
</template>

<script>
import GuidelineJobForm from '@/modules/job-evaluation/components/supplies/guideline-model/jobs-manager/guideline-job-form';
import GuidelineJobList from '@/modules/job-evaluation/components/supplies/guideline-model/jobs-manager/job-list/guideline-job-list';
import GuidelineModelInstructions from '@/modules/job-evaluation/components/supplies/guideline-model/jobs-manager/guideline-model-instructions';
import { filter, isEmpty, findIndex, propEq, prop, isNil, pathOr, all, clone } from 'ramda';
import GuidelineJobSelector from '@/modules/job-evaluation/components/supplies/guideline-model/jobs-manager/guideline-job-selector';
import { mapState } from 'vuex';
import { generateJob, verifyJobIsCompleted } from '../../../helpers/helpers';

export default {
	name: 'page-supply-guideline-model',
	components: {
		GuidelineJobSelector,
		GuidelineModelInstructions,
		GuidelineJobList,
		GuidelineJobForm,
	},
	computed: {
		...mapState('jobEvaluation', {
			jobList: pathOr([], ['supplies', 'guidelineModel', 'userForm', 'jobList']),
		}),
		jobIsSelected() { return !isEmpty(this.selectedJob); },
		selectedIndex() { return findIndex(propEq('name', this.selectedJob.name), this.jobList); },
		selectedNext() {
			return prop(this.selectedIndex + 1, this.jobList);
		},
		selectedPrev() {
			return this.selectedIndex - 1 > -1 ? prop(this.selectedIndex - 1, this.jobList) : undefined;
		},
		selectionIsReady() {
			return all(propEq('completed', true), this.jobList);
		},
	},
	data() {
		return {
			selectedJob: {},
		};
	},
	methods: {
		onJobNameAdded(jobName) {
			this.$store.dispatch('jobEvaluation/updateJobList', [...this.jobList, generateJob(jobName)]);
		},
		onDeleteClick(selectedJob) {
			const jobList = filter(job => job.name !== selectedJob.name, this.jobList);
			this.$store.dispatch('jobEvaluation/updateJobList', jobList);
		},
		onEditionClick(selectedJob) {
			this.selectedJob = selectedJob;
			this.$refs.jobSelector.prevLocalPage();
		},
		onInfoClick() {
			this.selectedJob = {};
		},
		onNextClick() {
			if (!isNil(this.selectedNext)) {
				this.selectedJob = this.selectedNext;
			}
		},
		onPrevClick() {
			if (!isNil(this.selectedPrev)) {
				this.selectedJob = this.selectedPrev;
			}
		},
		onSelectedJobDataChanged(job) {
			const modifiedJob = clone(job);
			modifiedJob.completed = verifyJobIsCompleted(job);
			this.selectedJob = modifiedJob;
			this.$store.dispatch('jobEvaluation/updateJobItem', modifiedJob);
		},
		onGenerateHierarchyClick() {
			this.$store.dispatch('jobEvaluation/assignHierarchy')
				.then(() => {
					this.goTo('job-supply-guideline-model-hierarchy');
				})
				.catch((e) => { console.error(e); });
		},
	},
};
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/modules/job-evaluation/pages/supplies/guideline-model/page-supply-guideline-model.vue